import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '@Commons';

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 36px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${COLORS.disabled};
  background: ${COLORS.white};
`;
export const SubContainer = styled.div`
  justify-content: center;
`;

export const RemitterDetailsHeading = styled.p`
  color: ${COLORS.disabled};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px;
  line-height: 26px;
`;

export const NameValuePair = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
`;

export const Labels = styled.h5`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  line-height: 26px;
  white-space: nowrap;
  display: inline-block;
`;

export const Value = styled.p`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  margin: 2px 0px 0px 5px;
  display: inline-block;
`;

export const AddressContainer = styled.div`
  .addressLabel {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    line-height: 26px;
  }
  .addressValue {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
`;
